import React from "react";
import type { TypeRatingProps } from "./RatingTypes";
import RatingHybrid from "./RatingHybrid";

/**
 * Rating component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Rating = React.forwardRef<HTMLDivElement, TypeRatingProps>(
  (props, ref) => <RatingHybrid {...props} ref={ref} />
);

Rating.displayName = "Rating";
export default Rating;
